import db from "../db.js";

// keys are the Monsternames inspection (destination), values are the source inspections in terms of data/images
const inspRelations = new Map([    
    ['Monsternames Chroom VI', ['MN Chroom VI incl. Analyse']],
    ['Registeratieform InspX', ['MN Legionella incl. Analyse', 'MN Legionella Proceswater incl. Analyse']]
]);

export async function checkRelatedRPSInspections(currentInsp) {
    let result = true;
    if (currentInsp && Array.from(inspRelations.keys()).includes(currentInsp.type.name)) {
        let sourceTypes = inspRelations.get(currentInsp.type.name);
        let relatedInspectionsCount = await db.inspections
            .where({
                customerId: currentInsp.customerId,
                projectName: currentInsp.projectName,
                status: 'inProgress'
            })
            .filter(i => i._key !== currentInsp._key && sourceTypes.includes(i.type.name))
            .count()
            .catch(a => console.error(a));
        result = (relatedInspectionsCount === 0);
    }
    return result;
}
